var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("account-plan-message-modal", {
    ref: "modal",
    attrs: { id: "cancel-plan-confirmation-modal" },
    on: {
      hide: function ($event) {
        _vm.computedShown = false
      },
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("account.accountPlan.planModals.paymentFailed.title")
                ) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("p", { staticClass: "text-gray" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "account.accountPlan.planModals.paymentFailed.bodyText",
                      {
                        expirationDate: _vm.planCancellationDate,
                      }
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c("account-plan-perks", {
              attrs: { plan: _vm.freeAccountPlan, perks: false },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "text-gray mt-2" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "account.accountPlan.planModals.paymentFailed.bodyTextEnd"
                    )
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("simple-button", { on: { click: _vm.handleGoToAccountPlan } }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("account.accountPlan.gotToAccountPlanPage")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }